import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 13.4 15.4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.7 0.7V10.5M2.2 7.7L6.7 11.9L11.2 7.7M0.7 14.7H12.7",
		stroke: "currentColor",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgExport;
